(function () {
  // Panier commun : page /cart (#pcPage) et tiroir (#patDraw). Chaque zone [data-pc-root] est re-rendue
  // par Shopify (Section Rendering API) après un changement : le HTML vient toujours des snippets pat-cart-*.
  if (window.ppCart) return;
  const DRAWER = 'pat-cart-drawer';
  const draw = document.getElementById('patDraw');
  const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const onCartPage = () => !!document.getElementById('pcPage');
  const P = () => window.Patoon;
  let busy = false;

  function setBadge(count) {
    document.querySelectorAll('#patCartCount').forEach((el) => {
      el.textContent = String(count);
      el.hidden = count < 1;
    });
  }

  function panel() {
    return draw && draw.querySelector('.pat-draw-panel');
  }

  function openDraw() {
    if (!draw) return;
    draw.hidden = false;
    document.body.classList.add('pat-draw-lock');
    panel().focus();
    if (P()) P().refresh();
  }

  function closeDraw() {
    if (!draw) return;
    draw.hidden = true;
    document.body.classList.remove('pat-draw-lock');
  }

  // Sections à demander : la page panier contient aussi le tiroir (dans le footer)
  function wanted() {
    const page = document.getElementById('pcPage');
    return page ? [page.dataset.section] : [DRAWER];
  }

  function bindHover(scope) {
    scope.querySelectorAll('.pc-sum .pc-go, .pat-draw-ft .pc-go').forEach((g) => {
      if (g.dataset.pcHover) return;
      g.dataset.pcHover = '1';
      g.addEventListener('mouseenter', () => P() && P().react(g, 'beg', { ms: 60000 }));
      g.addEventListener('mouseleave', () => P() && P().react(g, 'proud', { ms: 10 }));
    });
  }

  function after() {
    if (window.ppDates) window.ppDates.fill();
    bindHover(document);
    if (P()) P().refresh();
    const r = document.querySelector('[data-pc-root]');
    if (r) setBadge(+r.dataset.count || 0);
  }

  // Remplace chaque zone [data-pc-root] par sa version fraîche ; false si une réponse manque
  function apply(sections) {
    if (!sections) return false;
    let done = 0;
    Object.keys(sections).forEach((id) => {
      if (!sections[id]) return;
      const doc = new DOMParser().parseFromString(sections[id], 'text/html');
      doc.querySelectorAll('[data-pc-root]').forEach((fresh) => {
        const cur = document.querySelector('[data-pc-root][data-section="' + fresh.dataset.section + '"]');
        if (!cur) return;
        cur.replaceWith(document.importNode(fresh, true));
        done++;
      });
    });
    after();
    return done > 0;
  }

  function scopeOf(section) {
    return document.querySelector('[data-pc-root][data-section="' + section + '"]');
  }

  async function change(btn) {
    const line = btn.closest('.pc-line');
    const root = btn.closest('[data-pc-root]');
    if (!line || !root || busy) return;
    busy = true;
    const section = root.dataset.section;
    const key = line.dataset.key;
    const q = Math.max(0, +btn.dataset.pcQty || 0);
    const cur = +(line.querySelector('.pc-qty span') || {}).textContent || 0;
    const btnIdx = [...line.querySelectorAll('[data-pc-qty]')].indexOf(btn);
    if (q === 0) line.classList.add('pc-out');
    try {
      const res = await fetch(base + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: q, sections: wanted(), sections_url: location.pathname }),
      });
      const j = await res.json();
      if (!res.ok || j.status) throw new Error(j.description || j.message || '');
      if (!apply(j.sections)) {
        location.reload();
        return;
      }
      setBadge(j.item_count || 0);
      const scope = scopeOf(section);
      if (scope && P()) {
        scope.querySelectorAll('.pc-go.pp-sit-host').forEach((g) => {
          if (q > cur) P().react(g, 'love', { fx: 'hearts', ms: 1800 });
          else P().react(g, 'sad', { ms: 1600 });
        });
      }
      // Le focus revient sur le même bouton de la même ligne, sinon sur le panneau
      const nl = scope && scope.querySelector('.pc-line[data-key="' + key + '"]');
      const nb = nl && nl.querySelectorAll('[data-pc-qty]')[btnIdx];
      if (nb) nb.focus();
      else if (section === DRAWER && panel()) panel().focus();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: j }));
    } catch (err) {
      line.classList.remove('pc-out');
      let msg = line.querySelector('.pc-err');
      if (!msg) {
        msg = document.createElement('p');
        msg.className = 'pc-err';
        msg.setAttribute('role', 'alert');
        line.querySelector('.pc-row').after(msg);
      }
      msg.textContent = err && err.message ? err.message : 'Oups, réessayez dans un instant.';
      if (P()) P().react('[data-pc-root] .pc-go.pp-sit-host', 'curious', { ms: 1600 });
    } finally {
      busy = false;
    }
  }

  async function refresh() {
    const res = await fetch(location.pathname + '?sections=' + wanted().join(','));
    if (!res.ok) throw new Error('sections');
    apply(await res.json());
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-pat-draw-open]')) {
      if (onCartPage() || !draw) return;
      e.preventDefault();
      openDraw();
      return;
    }
    if (e.target.closest('[data-pat-draw-close]')) {
      closeDraw();
      return;
    }
    const q = e.target.closest('[data-pc-qty]');
    if (!q || !q.closest('[data-pc-root]')) return;
    e.preventDefault();
    change(q);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && draw && !draw.hidden) closeDraw();
  });

  // Après un ajout (fiche, ajout rapide) : mise à jour du tiroir et du compteur.
  // detail.silent : la carte Patoon « Il va l'adorer ! » confirme l'ajout, le tiroir reste fermé.
  document.addEventListener('cart:refresh', (e) => {
    const silent = !!(e.detail && e.detail.silent);
    refresh()
      .catch(() => {})
      .then(() => {
        const live = document.getElementById('patCartLive');
        if (live) live.textContent = 'Article ajouté au panier.';
        if (!silent && !onCartPage()) openDraw();
      });
  });

  window.ppCart = { open: openDraw, close: closeDraw, refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', after);
  else after();
})();
